const checkInvalidSelectedValue = ( selectedValue, filteredValue ) => {
  let inValidSelection = selectedValue.filter( a => filteredValue.some( b => a.id === b.id ) === false );
  let ids = inValidSelection.map( selection => selection.id );
  return ids;
}; 

export default checkInvalidSelectedValue;